import { render, staticRenderFns } from "./ProductionAdmin.vue?vue&type=template&id=3fcdee08&scoped=true&"
import script from "./ProductionAdmin.vue?vue&type=script&lang=js&"
export * from "./ProductionAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProductionAdmin.vue?vue&type=style&index=0&id=3fcdee08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcdee08",
  null
  
)

export default component.exports